function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { conditionalRetryWithBackOff } from "../utils/backoff";
export var AuthServiceProvider = /*#__PURE__*/ function() {
    "use strict";
    function AuthServiceProvider(provider) {
        _class_call_check(this, AuthServiceProvider);
        _define_property(this, "provider", void 0);
        if (AuthServiceProvider.instance) {
            if (provider) {
                AuthServiceProvider.instance.setProvider(provider);
            }
            return AuthServiceProvider.instance;
        }
        AuthServiceProvider.instance = this;
        if (provider) {
            this.setProvider(provider);
        }
    }
    _create_class(AuthServiceProvider, [
        {
            key: "isOktaProvider",
            value: function isOktaProvider(provider) {
                return "tokenManager" in provider;
            }
        },
        {
            key: "isPkceProvider",
            value: function isPkceProvider(provider) {
                return "renewAccessToken" in provider;
            }
        },
        {
            key: "setProvider",
            value: function setProvider(provider) {
                this.provider = provider;
            }
        },
        {
            key: "getAccessToken",
            value: function getAccessToken() {
                var _this = this;
                return _async_to_generator(function() {
                    var token;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.provider) return [
                                    2
                                ];
                                if (!_this.isOktaProvider(_this.provider)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.provider.tokenManager.get("accessToken")
                                ];
                            case 1:
                                token = _state.sent();
                                if (token) {
                                    return [
                                        2,
                                        {
                                            access_token: token.accessToken,
                                            expires_at: token.expiresAt
                                        }
                                    ];
                                }
                                return [
                                    2
                                ];
                            case 2:
                                if (!_this.isPkceProvider(_this.provider)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.provider.getAccessToken()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "renewAccessToken",
            value: function renewAccessToken() {
                var _this = this;
                return _async_to_generator(function() {
                    var token;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.provider) return [
                                    2
                                ];
                                if (!_this.isOktaProvider(_this.provider)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.provider.tokenManager.renew("accessToken")
                                ];
                            case 1:
                                token = _state.sent();
                                if (token) {
                                    return [
                                        2,
                                        {
                                            access_token: token.accessToken,
                                            expires_at: token.expiresAt
                                        }
                                    ];
                                } else {
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 2;
                            case 2:
                                if (!_this.isPkceProvider(_this.provider)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    conditionalRetryWithBackOff(_this.provider.renewAccessToken.bind(_this.provider), _this.provider.isPending.bind(_this.provider), {
                                        condition: false
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isPending",
            value: function isPending() {
                if (!this.provider) {
                    return false;
                }
                if (this.isOktaProvider(this.provider)) {
                    console.error("Not implemented.");
                    return false;
                }
                return this.provider.isPending();
            }
        },
        {
            key: "isAuthenticated",
            value: function isAuthenticated(accountId) {
                var _this = this;
                return _async_to_generator(function() {
                    var accessToken;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.provider) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                if (_this.isOktaProvider(_this.provider)) {
                                    accessToken = _this.provider.tokenManager.getTokensSync().accessToken;
                                    return [
                                        2,
                                        Boolean(accessToken && !_this.provider.tokenManager.hasExpired(accessToken))
                                    ];
                                }
                                if (!_this.isPkceProvider(_this.provider)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionalRetryWithBackOff(_this.provider.isAuthenticated.bind(_this.provider), _this.provider.isPending.bind(_this.provider), {
                                        condition: false
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    4,
                                    conditionalRetryWithBackOff(_this.provider.isAuthenticated.bind(_this.provider, accountId), _this.provider.isPending.bind(_this.provider), {
                                        condition: false
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "login",
            value: function login() {
                if (!this.provider) return;
                if (this.isOktaProvider(this.provider)) {
                    console.error("Not implemented.");
                    return;
                }
                if (this.isPkceProvider(this.provider)) {
                    return this.provider.login();
                }
            }
        },
        {
            key: "logout",
            value: function logout() {
                if (!this.provider) return;
                if (this.isOktaProvider(this.provider)) {
                    return this.provider.signOut();
                }
                if (this.isPkceProvider(this.provider)) {
                    return this.provider.logout();
                }
            }
        }
    ]);
    return AuthServiceProvider;
}();
_define_property(AuthServiceProvider, "instance", void 0);

//# sourceMappingURL=auth-service-provider.js.map